<template>
  <div class="row">
    <loading-overlay :isLoading="loading"></loading-overlay>
    <div class="col-12">
      <card :title="'Clienti'">
        <base-table :data="tableData"
                    :columns="columns">
          <template slot="columns">
            <th class="text-left">#</th>
            <th>Nume</th>
            <th>Email</th>
            <th>Telefon</th>
            <th class="text-right">
              <base-button v-tooltip="'Adauga client nou'" @click="addCustomer" type="info" size="sm" icon>
                <i class="tim-icons icon-simple-add"></i>
              </base-button>
            </th>
          </template>
          <template slot-scope="{row}">
            <td  @click="testClick">{{row.id}}</td>
            <td  @click="testClick">{{row.nume}}</td>
            <td  @click="testClick">{{row.email}}</td>
            <td  @click="testClick">{{row.tel}}</td>
            <td class="td-actions text-right">
              <base-button v-tooltip="'Vezi proiectele clientului'" @click="viewCustomerProjects(row)" type="info" size="sm" icon>
                <i class="tim-icons icon-single-copy-04"></i>
              </base-button>
              <base-button v-tooltip="'Editeaza date client'" @click="editCustomer(row)" type="success" size="sm" icon style="margin-left: 10px">
                <i class="tim-icons icon-settings"></i>
              </base-button>
              <base-button v-tooltip="'Sterge client'" @click="deleteCustomer(row)" type="danger" size="sm" icon style="margin-left: 10px">
                <i class="tim-icons icon-simple-remove"></i>
              </base-button>
            </td>
          </template>
        </base-table>
        <div v-if="tableData.length < 1 && !loading" style="text-align: center">
          <h6 class="blockquote">Nu exista clienti adaugati!</h6>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
  import { BaseTable } from "@/components";
  import axios from "axios";
  import LoadingOverlay from "../../components/Loading/LoadingOverlay";

  export default {
    components: {LoadingOverlay, BaseTable},
    data() {
      return {
        columns: ['Nume', 'Email', 'Telefon', ''],
        tableData: [],
        loading: false,
      }
    },
    created() {
      this.getData();
    },
    methods: {
      getData() {
        this.loading = true;
        axios.get('/customers')
                .then(res => {
                  this.loading = false;
                  this.tableData = res.data;
                })
                .catch(err => {
                  this.loading = false;
                  console.log(err);
                })
      },
      addCustomer() {
        this.$router.push({name: 'customer-add'});
      },
      editCustomer(customer) {
        this.$router.push({name: 'customer-edit', params: {customerId: customer.id} });
      },
      deleteCustomer(customer) {
        let self = this;
        this.$dialog.confirm('Esti sigur ca vrei sa stergi clientul "' + customer.nume + '"?', {
          okText: 'Da',
          cancelText: 'Nu'
        })
                .then(() => {
                  axios.post('customer/delete', {id: customer.id})
                          .then(() => {
                            self.getData();
                          })
                          .catch((err) => {
                            console.log(err);
                          });
                })
                .catch(() => {
                })
      },
      viewCustomerProjects(customer) {
        this.$router.push({name: 'projects', params: {customerId: customer.id}});
      },
      testClick() {
        console.log('test');
      },
    }
  }
</script>
